import { Avatar, Space, Typography, Divider } from "antd";
import { Mail, Phone, IdCard, MapPin } from "lucide-react";

import { UserByOrder } from "../../../../redux/@types";

const { Text, Title } = Typography;

export interface ShippingProps {
  id: number;
  name: string;
  address: string;
  user_id: number;
  city_id: number;
  state_id: number;
  lat: null;
  lng: null;
  details: string;
  main: string;
  integration_nit: null;
  integration_codigo_direccion: null;
  deletedAt: null;
  createdAt: Date;
  updatedAt: Date;
  address_name: string;
  address_id: number;
  state_name: string;
  state_integration_id: string;
  city_name: string;
  city_integration_id: string;
  dane_code: string;
  fulfillment_company_id: number;
}
interface Props {
  dataUser: UserByOrder;
  shipping: ShippingProps;
}

export const InfoUserCard = ({ shipping, dataUser }: Props) => {
  return (
    <div style={{ width: "100%" }}>
      {/* Información del cliente */}
      <Space direction="vertical" size={16} style={{ width: "100%" }}>
        {/* Header con avatar y nombre */}
        <Space size={16} align="start">
          <Avatar
            size={64}
            style={{
              background: "#E95735",
              fontSize: 24,
              fontWeight: 600,
            }}
          >
            {dataUser.first_name?.charAt(0)}{dataUser.last_name?.charAt(0)}
          </Avatar>
          <div>
            <Title 
              level={4} 
              style={{ 
                margin: 0, 
                marginBottom: 4,
                color: "#262626",
                fontWeight: 600
              }}
            >
              {`${dataUser.first_name} ${dataUser.last_name}`}
            </Title>
            <Space direction="vertical" size={6}>
              <Space size={8}>
                <Mail size={14} style={{ color: "#8c8c8c" }} />
                <Text style={{ fontSize: 13, color: "#595959" }}>
                  {dataUser.email}
                </Text>
              </Space>
              <Space size={8}>
                <Phone size={14} style={{ color: "#8c8c8c" }} />
                <Text style={{ fontSize: 13, color: "#595959" }}>
                  {dataUser.phone}
                </Text>
              </Space>
              <Space size={8}>
                <IdCard size={14} style={{ color: "#8c8c8c" }} />
                <Text style={{ fontSize: 13, color: "#595959" }}>
                  {`${dataUser.dni_type === "cedula" ? "Cédula" : dataUser.dni_type} #${dataUser.dni}${dataUser.dni_type === "nit"? ` - ${dataUser.company_legal_name}`: ""}`}
                </Text>
              </Space>
            </Space>
          </div>
        </Space>

        <Divider style={{ margin: "8px 0" }} />

        {/* Datos de envío */}
        <div>
          <Space size={8} style={{ marginBottom: 12 }}>
            <MapPin size={16} style={{ color: "#E95735" }} />
            <Text strong style={{ fontSize: 14, color: "#262626" }}>
              Dirección de envío
            </Text>
          </Space>
          <Space direction="vertical" size={4} style={{ paddingLeft: 24 }}>
            <Text style={{ fontSize: 13, color: "#595959" }}>
              {shipping.address}
            </Text>
            {shipping.details && (
              <Text style={{ fontSize: 12, color: "#8c8c8c" }}>
                {shipping.details}
              </Text>
            )}
            <Text style={{ fontSize: 13, color: "#595959" }}>
              {`${shipping.city_name}, ${shipping.state_name}`}
            </Text>
          </Space>
        </div>
      </Space>
    </div>
  );
};
